module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Arabic.75527903.ttf";